<div class="tos-card-row" >
    <mat-card>
      <mat-card-content>
        <a routerLink="/privacy-statement" target="_blank">
          {{ 'ONETRUST.privacy_policy' | translate }}
          </a>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-content>
        <a routerLink="/terms-of-use" target="_blank">
          {{ 'ONETRUST.tos' | translate }}
        </a>
      </mat-card-content>
    </mat-card>
</div>
